<template lang="pug">
    .validating-card
        .validating-card__header
            Avatar.validating-card__header-image(
                :img='data.icon'
                :alt='data.name'
                circle
            )
            .validating-card__header-info
                .validating-card__header-name {{data.name}}
                .validating-card__header-specialty {{data.specialty}}

        .validating-card__body
            p.validating-card__body-text
                | {{data.text}}

        .validating-card__footer
            .validating-card__footer-status
                Icon.validating-card__footer-type(
                    :icon="data.type"
                )
                span.validating-card__footer-tooltip( v-tiny-text-tooltip="{text: tooltip}")
            .validating-card__footer-media
                Icon.validating-card__footer-type(
                    icon="vk-color"
                )
                Icon.validating-card__footer-type(
                    icon="fb-color"
                )
                Icon.validating-card__footer-type(
                    icon="insta-color"
                )
        OptionsList.validating-card-option(
            :optionsFields="optionsFields"
        )
</template>
<script>
export default {
  name: 'Card',
  props: {
    data: {}
  },
  data() {
    return {
      optionsFields: [
        {
          text: 'Редактировать',
          func: this.openBlockEdit,
          icon: 'edit'
        },
        {
          text: 'Удалить',
          func: this.removeBlockEdit,
          icon: 'delete',
          red: true
        }
      ]
    };
  },
  computed: {
    tooltip() {
      switch (this.data.type) {
        case 'lider':
          return 'Лидер';
        case 'guard':
          return 'Хранитель';
        case 'volonter':
          return 'Волонтер';

        default:
          return undefined;
      }
    }
  },
  methods: {
    openBlockEdit() {
      this.$emit('click', this.data.id);
    }
  }
};
</script>
